import styled from 'styled-components';

interface Props {
  width?: string;
}

export const ExclamationIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #666666;
  color: #ffffff;
  height: 20px;
  width: 20px;
  margin-right: 8px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  transform: rotate(180deg);
`;

export const InfoPhones = styled.div`
  display: flex;
  width: 370px;
  align-items: center;
  color: #666666;
  margin-top: 8px !important;
  margin-bottom: 32px;
  p {
    margin: 0;
    width: 90%;
    font-size: 12px;
  }
  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const FormInput = styled.div<Props>`
  width: 100%;
`;
